import * as _ from "./utils.js";
const languagePreference = {
  store: null,
  path: "",
  defaults: ["en"],
  getLanguages,
  selectLanguage
};
function getLanguages() {
  return _.get(languagePreference.store, languagePreference.path) || languagePreference.defaults;
}
function selectLanguage(languageMap) {
  if (!languageMap) {
    return null;
  }
  for (let language of getLanguages()) {
    if (languageMap[language]) {
      return language;
    }
  }
  for (let language of Object.keys(languageMap)) {
    if (language != "-") {
      return language;
    }
  }
  return null;
}
var language_preference_default = languagePreference;
export {
  language_preference_default as default
};
